module.exports = __webpack_public_path__ + "static/media/img04.90480338.webp";